import { AlertFactory } from 'alerts/Alert'
import PromptStore from 'jobs/prompts/PromptStore'
import JobViewModel from 'jobs/views/JobRoot/Job/JobViewModel'
import CallRootViewModel from 'messaging/calling/CallRootViewModel'
import VideoCallStore from 'messaging/calling/VideoCallStore'
import VoiceCallStore from 'messaging/calling/VoiceCallStore'
import { ConversationViewModelPort } from 'messaging/components/ConversationView/ConversationViewModel'
import ConversationStore from 'messaging/ConversationStore'
import { Id } from 'types/definitions'

export default function JobConversationViewModelAdapter(
  newAlert: AlertFactory,
  conversationStore: ConversationStore,
  videoCallStore: VideoCallStore,
  callRootViewModel: CallRootViewModel,
  promptStore: PromptStore,
  jobViewModel: JobViewModel,
  voiceCallStore: VoiceCallStore
): ConversationViewModelPort {
  return {
    newAlert,
    fetchMessages: conversationStore.fetchMessages,
    sendMessage: jobViewModel.hasConversationManagePermission
      ? conversationStore.sendAdminMessage.bind(conversationStore)
      : conversationStore.sendMessage.bind(conversationStore),
    markAsRead: conversationStore.markAsRead,
    toggleMute: conversationStore.toggleMute,
    startCall: async (convo, invitees) =>
      callRootViewModel.startCall(convo, invitees),
    activeCallForConversation: (convo) => {
      const callVM = callRootViewModel.activeCall
      return callVM?.call.conversation === convo ? callVM : null
    },
    joinCall: async (call) => {
      await callRootViewModel.callViewModelFor(call).join()
    },
    fetchCall: async (callId: Id) => {
      await videoCallStore.fetchCall(callId)
    },
    fetchPrompt: async (promptId: Id) => {
      const existingPrompt = promptStore.prompts.get(promptId)
      if (existingPrompt?.question) {
        // In this case the prompt has already been loaded into memory so we don't need to
        // fetch it again.
        return
      }

      await promptStore.getPrompt(promptId)
    },
    jobProgressionAdapter: {
      canUpdateJobProgressionAsClient:
        jobViewModel.canUpdateJobProgressionAsClient,
      viewApproveDraftInReviewDialog:
        jobViewModel.approveDraftInReviewDialogVM.show,
      viewRejectDraftInReviewDialog:
        jobViewModel.rejectDraftInReviewDialogVM.show,
    },
    voiceCallStore,
  }
}
